import React from 'react';
import CreateSprintModal from '../../CreateSprintModal';
import CreateTemplateModal from '../../CreateTemplateModal';
import SettingsModal from '../../SprintDetail/FlowchartView/components/SettingsModal';
export function AppModals({
  isCreateSprintOpen,
  closeCreateSprintModal,
  onSprintCreated,
  preselectedTemplate,
  parentSprintIdForNesting,
  templates,
  sprints,
  loadFullSprint,
  isCreateTemplateOpen,
  closeCreateTemplateModal,
  onTemplateCreated,
  isSettingsOpen,
  closeSettingsModal,
  preferences,
  updatePreferences,
}) {
  return (
    <>
      <CreateSprintModal
        isOpen={isCreateSprintOpen}
        onClose={closeCreateSprintModal}
        onSprintCreated={onSprintCreated}
        preselectedTemplate={preselectedTemplate}
        parentSprintId={parentSprintIdForNesting}
        templates={templates}
        allSprints={sprints}
        loadFullSprint={loadFullSprint}
      />
      <CreateTemplateModal
        isOpen={isCreateTemplateOpen}
        onClose={closeCreateTemplateModal}
        onTemplateCreated={onTemplateCreated}
      />
      <SettingsModal
        isOpen={isSettingsOpen}
        onClose={closeSettingsModal}
        preferences={preferences}
        onPreferencesChange={updatePreferences}
      />
    </>
  );
}
